import {
  Alert,
  AlertTitle,
  Box,
  Button,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UndoIcon from "@mui/icons-material/Undo";

// Persistent list of mid-stay placement/removal advisories. Stays on screen
// (unlike a toast) until the user undoes/dismisses an entry, clears them all,
// or the board reloads on a date/campus change or save.
//   - Undo  : reverts the move that raised it (back to the prior room) and clears it.
//   - × Dismiss : just hides it (the change stands — use when the warning is fine).
function BedroomWarningsPanel({ warnings, onUndo, onDismiss, onClearAll }) {
  if (!warnings || warnings.length === 0) return null;

  const count = warnings.reduce((n, w) => n + (w.messages?.length || 0), 0);

  return (
    <Box sx={{ width: "100%", mb: 2 }}>
      <Alert
        severity="warning"
        action={
          <Button color="inherit" size="small" onClick={onClearAll}>
            Clear all
          </Button>
        }
      >
        <AlertTitle>
          {count} room warning{count === 1 ? "" : "s"}
        </AlertTitle>
        <Stack spacing={0.75}>
          {warnings.map((w) => (
            <Box
              key={w.residentId}
              sx={{ display: "flex", alignItems: "flex-start", gap: 0.5 }}
            >
              <Box sx={{ flexGrow: 1 }}>
                {w.messages.map((message, index) => (
                  <Typography key={index} variant="body2">
                    <strong>{w.name}</strong> — {message}
                  </Typography>
                ))}
              </Box>
              <Button
                size="small"
                color="inherit"
                startIcon={<UndoIcon fontSize="inherit" />}
                onClick={() => onUndo(w.residentId)}
              >
                Undo
              </Button>
              <IconButton
                size="small"
                onClick={() => onDismiss(w.residentId)}
                aria-label={`Dismiss warning for ${w.name}`}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            </Box>
          ))}
        </Stack>
      </Alert>
    </Box>
  );
}

export default BedroomWarningsPanel;
